// extracted by mini-css-extract-plugin
module.exports = {"root":"PreloaderCustom_root__qCmYW","galaxy":"PreloaderCustom_galaxy__buuKb","spinner-rotate":"PreloaderCustom_spinner-rotate__Q99WF"};